export default {"src":"/images/8.jpg","width":5402,"height":3601,"aspectRatio":1.5001388503193558};